<template>
  <CallHelpTel />
  <a-tabs>
    <a-tab-pane key="1">
      <template #tab>
        <a href="#" :style="{ fontSize: fontSize.h5 + 'em' }" class="tab_title">
          <img src="../img/faq01.svg" alt="" />
          <div>行前注意事項</div>
        </a>
      </template>
      <ul uk-accordion>
        <li v-for="item in tabs.beforeGo.list" :key="item.id">
          <a
            class="uk-accordion-title"
            href="#"
            :style="{ fontSize: fontSize.h5 + 'em' }"
          >
            <div class="group">
              <p class="question">Q&ensp;</p>
              <p class="text_red">{{ item.pageTitle }} &ensp;</p>
            </div>
          </a>
          <div class="uk-accordion-content">
            <div :style="{ fontSize: fontSize.h2 + 'em' }" class="answer">
              A&ensp;
            </div>
            <div
              :style="{ fontSize: fontSize.h5 + 'em' }"
              v-html="item.pageContent"
              class="answer_text"
            ></div>
          </div>
        </li>
      </ul>
      <div class="faq_paganition">
        <a-pagination
          v-if="
            tabs.beforeGo.pagination.total > tabs.beforeGo.pagination.pageSize
          "
          v-model:current="tabs.beforeGo.pagination.current"
          v-model:total="tabs.beforeGo.pagination.total"
          v-model:pageSize="tabs.beforeGo.pagination.pageSize"
          @change="changeBeforeGoPage"
          :style="{ fontSize: fontSize.p + 'em' }"
        ></a-pagination>
      </div>
    </a-tab-pane>

    <a-tab-pane key="2" force-render>
      <template #tab>
        <a href="#" :style="{ fontSize: fontSize.h5 + 'em' }" class="tab_title">
          <img src="../img/faq02.svg" alt="" />
          <div>海外就業注意事項</div>
        </a>
      </template>
      <ul uk-accordion>
        <li v-for="item in tabs.onJob.list" :key="item.id">
          <a
            class="uk-accordion-title"
            href="#"
            :style="{ fontSize: fontSize.h5 + 'em' }"
          >
            <div class="group">
              <p :style="{ fontSize: fontSize.p + 'em' }" class="question">
                Q&ensp;
              </p>
              <p :style="{ fontSize: fontSize.p + 'em' }" class="text_red">
                {{ item.pageTitle }} &ensp;
              </p>
            </div>
          </a>
          <div class="uk-accordion-content">
            <div :style="{ fontSize: fontSize.h2 + 'em' }" class="answer">
              A&ensp;
            </div>
            <div
              :style="{ fontSize: fontSize.h5 + 'em' }"
              v-html="item.pageContent"
              class="answer_text"
            ></div>
          </div>
        </li>
      </ul>
      <div class="faq_paganition">
        <a-pagination
          v-if="tabs.onJob.pagination.total > tabs.onJob.pagination.pageSize"
          v-model:current="tabs.onJob.pagination.current"
          v-model:total="tabs.onJob.pagination.total"
          v-model:pageSize="tabs.onJob.pagination.pageSize"
          @change="changeOnJobPage"
          :style="{ fontSize: fontSize.p + 'em' }"
        ></a-pagination>
      </div>
    </a-tab-pane>

    <a-tab-pane key="3">
      <template #tab>
        <a href="#" :style="{ fontSize: fontSize.h5 + 'em' }" class="tab_title">
          <img src="../img/faq03.svg" alt="" />
          <div>返國後資源協助</div>
        </a>
      </template>
      <ul uk-accordion>
        <li v-for="item in tabs.return.list" :key="item.id">
          <a
            class="uk-accordion-title"
            href="#"
            :style="{ fontSize: fontSize.h5 + 'em' }"
          >
            <div class="group">
              <p class="question">Q&ensp;</p>
              <p class="text_red">{{ item.pageTitle }} &ensp;</p>
            </div>
          </a>
          <div class="uk-accordion-content">
            <div :style="{ fontSize: fontSize.h2 + 'em' }" class="answer">
              A&ensp;
            </div>
            <div
              :style="{ fontSize: fontSize.h5 + 'em' }"
              v-html="item.pageContent"
              class="answer_text"
            ></div>
          </div>
        </li>
      </ul>
      <div class="faq_paganition">
        <a-pagination
          v-if="tabs.return.pagination.total > tabs.return.pagination.pageSize"
          v-model:current="tabs.return.pagination.current"
          v-model:total="tabs.return.pagination.total"
          v-model:pageSize="tabs.return.pagination.pageSize"
          @change="changeReturnPage"
          :style="{ fontSize: fontSize.p + 'em' }"
        ></a-pagination>
      </div>
    </a-tab-pane>
  </a-tabs>
</template>

<script>
import { reactive, inject } from "vue";
import { apiQa } from "@/api/api.js";

import CallHelpTel from "../components/Home/CallHelpTel.vue";

export default {
  name: "Faq",
  components: {
    CallHelpTel,
  },
  setup() {
    //  無障礙文字子層引入設定
    let fontSize = inject("fontSize");
    // 分頁狀態
    const tabs = reactive({
      beforeGo: {
        nodeId: 438,
        list: [],
        pagination: {
          total: 0,
          current: 1,
          pageSize: 6,
        },
      },
      onJob: {
        nodeId: 439,
        list: [],
        pagination: {
          total: 0,
          current: 1,
          pageSize: 6,
        },
      },
      return: {
        nodeId: 440,
        list: [],
        pagination: {
          total: 0,
          current: 1,
          pageSize: 6,
        },
      },
    });

    // 取得列表
    const getTabList = (nodeId, page = 1) => {
      apiQa({ nodeId, page })
        .then((res) => {
          switch (nodeId) {
            case 438:
              tabs.beforeGo.list = res.data.qa;
              tabs.beforeGo.pagination.total =
                res.data.totalPage * tabs.beforeGo.pagination.pageSize;
              break;
            case 439:
              tabs.onJob.list = res.data.qa;
              tabs.onJob.pagination.total =
                res.data.totalPage * tabs.onJob.pagination.pageSize;
              break;
            case 440:
              tabs.return.list = res.data.qa;
              tabs.return.pagination.total =
                res.data.totalPage * tabs.return.pagination.pageSize;
              break;
            default:
              break;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    };

    // 初始化
    for (let tab in tabs) {
      getTabList(tabs[tab].nodeId);
    }

    // 切換分頁
    const changePage = (nodeId, page) => {
      apiQa({ nodeId, page })
        .then((res) => {
          switch (nodeId) {
            case 438:
              tabs.beforeGo.list = res.data.qa;
              tabs.beforeGo.pagination.current = page;
              break;
            case 439:
              tabs.onJob.list = res.data.qa;
              tabs.onJob.pagination.current = page;
              break;
            case 440:
              tabs.return.list = res.data.qa;
              tabs.return.pagination.current = page;
              break;
            default:
              break;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    };
    const changeBeforeGoPage = (page) => {
      const nodeId = 438;
      changePage(nodeId, page);
    };
    const changeOnJobPage = (page) => {
      const nodeId = 439;
      changePage(nodeId, page);
    };
    const changeReturnPage = (page) => {
      const nodeId = 440;
      changePage(nodeId, page);
    };

    return {
      tabs,
      changeBeforeGoPage,
      changeOnJobPage,
      changeReturnPage,
      fontSize,
    };
  },
};
</script>
<style scoped lang="scss">
.group {
  align-items: center;
  display: flex;
  justify-content: flex-start;
}
.question {
  color: #cc4444;
}

.answer {
  font-size: $h1;
  color: $main_color;
  font-weight: bold;
}
.uk-accordion-content {
  display: flex;
  align-content: flex-start;
  padding: 10px 20px;
  margin: 5px 0 10px;
  border-bottom: 1.5px dashed $hr_gray;
  .answer_text {
    font-size: $h5;
    text-align: left;
  }

  p {
    text-align: left;
  }
}

.uk-accordion-title:hover .text_red[data-v-7a6425cc],
.uk-accordion-title:focus .text_red[data-v-7a6425cc] {
  color: #fff;
}
.uk-accordion-title:hover .question[data-v-7a6425cc],
.uk-accordion-title:focus .question[data-v-7a6425cc] {
  color: $main_sec_color;
}

.notice01::before {
  content: "000";
  background-image: url("../img/faq01.svg");
  background-position: center center;
  background-repeat: no-repeat;
  background-size: contain;
  position: absolute;
  left: 10px;
}
.tab_title {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: $h5;
}
.tab_wrap {
  width: 75%;
  margin: 0 auto;
  @include md {
    width: 100%;
  }
  .tab_item {
    @include flex_center();
    padding: 30px 0;
    img {
      width: 7%;
      margin-right: 10px;
      @include md {
        width: 11%;
      }
      @include xs {
        width: 13%;
      }
    }
  }
}

.uk-accordion-title {
  @include flex_between();
  text-align: left;
  background-color: #f8f6f3;
  padding: 10px 20px;
  @include md {
    font-size: $h5;
  }
}

//手風琴狀態設定
.uk-accordion-title:hover,
.uk-accordion-title:focus {
  color: #fff;
  background-color: $main_color;
}

.uk-accordion-title::after {
  content: "";
  width: 1.4em;
  height: 1.4em;
  margin-left: 10px;
  padding: 20px;
  float: right;
  background-image: url("../img/faq_down_blue.svg");
  background-repeat: no-repeat;
  background-position: 50% 50%;
}

.uk-open > .uk-accordion-title::after {
  background-image: url("../img/faq_up_yellow.svg");
}

.uk-accordion > :nth-child(n + 2) {
  margin-top: 10px;
}
.ant-tabs-nav-container-scrolling {
  @include md {
    width: 100%;
  }
}
.faq_paganition {
  padding-top: 20px;
}

@include xl {
  :deep .ant-tabs-nav .ant-tabs-tab {
    width: -webkit-fill-available !important;
    margin: 0 !important;
  }
  :deep .ant-tabs-ink-bar {
    display: none !important;
  }
}
</style>
